import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box, Card, AppBar, CircularProgress } from "@mui/material";
import RemoveBoxes from "./RemoveBoxes";
import NewBoxes from "./NewBoxes";
import { useSelector } from "react-redux";
import { useLocation } from 'react-router-dom'
import { callAPI } from "../../../axios";
import { getChainIdLS, isValidRole } from "../../../utils/utils";

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    );
};

const ReSyncChainId = () => {

    const location = useLocation();
    const [value, setValue] = useState(isValidRole("RE_SYNC_CHAINID_NEW_BOX")?1:0);
    const [loader, setLoader] = useState(false);
    const [reSynchChainIdFlag, setReSynchChainIdFlag] = useState(false);
    const [reSyncChainIdResponse, setReSyncChainIdResponse] = useState({});
    const [removedBoxesResponse, setRemovedBoxesResponse] = useState([]);
    const [unMappedBoxes, setUnMappedBoxes] = useState([]);
    const { chainId } = useSelector((state) => state.chainIdReducer);

    function a11yProps(index) {
        return {
            id: `full-width-tab-${index}`,
            "aria-controls": `full-width-tabpanel-${index}`,
            className: `eachtab ${value === index ? "Mui-selected" : ""}`,
        };
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const reSyncChainIdHandler = () => {
        setLoader(true);
        const apiPath = `/chainid/resync`;
        callAPI(apiPath, "GET", {}, { chainId: getChainIdLS() })
            .then((res) => {
                setReSynchChainIdFlag(true);
                setReSyncChainIdResponse(res);
                setRemovedBoxesResponse(res?.removedBoxes);
                setUnMappedBoxes(res?.unmappedBoxes);
                setLoader(false);
            })
            .catch((err) => {
                console.warn(err.message);
                setReSynchChainIdFlag(false);
                setLoader(false);
            });
    }

    const manuallyRemovedBoxesListHandler = (list) => {
        setRemovedBoxesResponse(list);
    }

    const manuallyRemovedUnMappedCdsnHandler = (list) => {
        setUnMappedBoxes(list);
    }

    useEffect(() => {
        setReSynchChainIdFlag(false);
        setValue(isValidRole("RE_SYNC_CHAINID_NEW_BOX")?1:0);
    }, [chainId])

    return (
        <div className='row config-hotel'>
            {loader && <div className="circular-progress"><CircularProgress /></div>}
            {/* {chainId.navSelectedhotelName?.[0]?.viewType === "custom" && location.pathname === "/hms/resyncchainid" && <div className='mask-content resynch-config'>This hotel is on TATA Play Hotel Solution. <br /> Please select Third Party hotel to proceed.</div>} */}
            <div className='col-12 left-column'>
                <Card className="resync_chainid">
                    <p className="cdsn-details">Re-Sync Chain ID</p>
                    <div className="resync-hotel">
                        <div className="details">
                            <p>Hotel Name</p>
                            <p>{Array.isArray(chainId?.navSelectedhotelName) && chainId.navSelectedhotelName.length > 0
                                ? chainId.navSelectedhotelName?.[0]?.name
                                : 'NA'}</p>
                        </div>
                        <div className="details">
                            <p>Chain ID</p>
                            <p>{Array.isArray(chainId?.navSelectedhotelName) && chainId.navSelectedhotelName.length > 0
                                ? chainId.navSelectedhotelName?.[0]?.enterpriseChainId === null ? 'NA' : chainId.navSelectedhotelName?.[0]?.enterpriseChainId : 'NA'}</p>
                        </div>
                        <div className="details">
                            <p>Hotel Type</p>
                            <p>{Array.isArray(chainId?.navSelectedhotelName) && chainId.navSelectedhotelName.length > 0
                                ? chainId.navSelectedhotelName?.[0]?.viewType === "custom" ? 'HMS' : 'Third Party'
                                : 'NA'}</p>
                        </div>
                        <div className="details text-end">
                            <button
                                type="button"
                                disabled={
                                    chainId.navSelectedhotelName?.[0]?.enterpriseChainId === null
                                }
                                onClick={reSyncChainIdHandler}
                                className={`create-btn ${
                                    chainId.navSelectedhotelName?.[0]?.enterpriseChainId === null
                                    ? 'opacity-75'
                                    : ''
                                    }`}
                            >
                                Re-Sync Chain ID
                            </button>
                            {/* <p>last synced 30 june 2025 4:30pm</p> */}
                        </div>
                    </div>
                </Card>
                {reSynchChainIdFlag && <Card className="mt-3 p-3">
                    <Box className="boxroot disable-tab">
                        <AppBar position="static">
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons="auto"
                                TabIndicatorProps={{
                                    hidden: true,
                                    style: { transition: "none" },
                                }}
                            >
                                <Tab disabled = {!isValidRole("RE_SYNC_CHAINID_REMOVE_BOX")} label="Remove Boxes" {...a11yProps(0)} />
                                <Tab disabled = {!isValidRole("RE_SYNC_CHAINID_NEW_BOX")} label="New Boxes" {...a11yProps(1)} />
                            </Tabs>
                        </AppBar>

                        <TabPanel value={value} index={0}>
                            <RemoveBoxes
                                chainId={chainId}
                                unMappedBoxes={unMappedBoxes}
                                manuallyRemovedUnMappedCdsnHandler={manuallyRemovedUnMappedCdsnHandler}
                                removedBoxesResponse={removedBoxesResponse}
                                manuallyRemovedBoxesListHandler={manuallyRemovedBoxesListHandler} />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <NewBoxes reSyncChainIdResponse={reSyncChainIdResponse} />
                        </TabPanel>
                    </Box>
                </Card>}
            </div>
        </div>
    )
}

export default ReSyncChainId;